'use client';
import React from 'react';

const latestVideos = [
{
  category: 'COSMOLOGY',
  date: 'Jun 15, 2025',
  title: 'The Big Bang Explained: What Actually Happened in the First Second',
  duration: '18:42',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_19a292dc2-1781815454359.png",
  alt: 'Visualization of the Big Bang explosion showing the rapid expansion of the early universe from a singularity',
  views: '24.3K'
},
{
  category: 'BIOLOGY',
  date: 'Jun 10, 2025',
  title: 'The Origin of Eukaryotic Cells: When Life Got Complex',
  duration: '22:15',
  thumbnail: "https://images.unsplash.com/photo-1707861107128-9117f3ba988c",
  alt: 'Electron microscope image of eukaryotic cells showing nucleus and organelles in detail',
  views: '18.7K'
},
{
  category: 'PHILOSOPHY',
  date: 'Jun 5, 2025',
  title: 'Does the Universe Have a Purpose? The Teleology Debate',
  duration: '31:08',
  thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_11c7a8033-1781815451775.png",
  alt: 'Abstract philosophical visualization showing interconnected concepts and the question of universal purpose',
  views: '31.2K'
}];


export default function VideosSection() {
  return (
    <section id="videos" className="bg-[#0a0e1a] py-10 border-b border-[#1e2a3a]">
      <div className="max-w-[1280px] mx-auto px-6 md:px-16">
        <div className="flex items-center justify-between mb-6">
          <h2
            className="text-white font-semibold"
            style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '25.6px', fontWeight: 500 }}>
            
            Latest Videos
          </h2>
          <a
            href="#videos"
            className="text-[#e01a2e] text-sm font-semibold hover:text-white transition-colors duration-200 flex items-center gap-1"
            style={{ fontFamily: 'Roboto, sans-serif' }}>
            
            Watch All
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {latestVideos.map((video, i) =>
          <VideoCard key={i} video={video} />
          )}
        </div>
      </div>
    </section>);

}

function VideoCard({ video }: {video: typeof latestVideos[0];}) {
  return (
    <div className="group cursor-pointer bg-[#0d1120] border border-[#1e2a3a] hover:border-[#e01a2e] rounded-sm overflow-hidden transition-all duration-300 hover:shadow-[0_4px_20px_rgba(224,26,46,0.12)]">
      {/* Thumbnail */}
      <div className="relative overflow-hidden" style={{ aspectRatio: '16/9' }}>
        <img
          src={video.thumbnail}
          alt={video.alt}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
        
        <div className="absolute inset-0 bg-[#070a14]/50 group-hover:bg-[#070a14]/30 transition-colors duration-300" />
        {/* Play Button */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-14 h-14 rounded-full bg-[#e01a2e]/90 group-hover:bg-[#e01a2e] flex items-center justify-center transition-all duration-300 group-hover:scale-110 shadow-[0_0_20px_rgba(224,26,46,0.4)]">
            <svg className="w-6 h-6 text-white ml-1" fill="currentColor" viewBox="0 0 24 24">
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        </div>
        {/* Duration Badge */}
        <span
          className="absolute bottom-2 right-2 text-[11px] font-bold px-2 py-0.5 rounded-sm"
          style={{
            fontFamily: 'Roboto, sans-serif',
            background: 'rgba(7,10,20,0.85)',
            color: '#fff'
          }}>
          
          {video.duration}
        </span>
        {/* Category Badge */}
        <span
          className="absolute top-2 left-2 text-[9px] font-bold tracking-widest px-2 py-0.5 rounded-sm"
          style={{
            fontFamily: 'Roboto, sans-serif',
            background: 'rgba(224,26,46,0.9)',
            color: '#fff'
          }}>
          
          {video.category}
        </span>
      </div>

      {/* Info */}
      <div className="p-4">
        <div className="flex items-center gap-3 mb-2">
          <span className="text-[#4a5568] text-[11px]" style={{ fontFamily: 'Roboto, sans-serif' }}>
            {video.date}
          </span>
          <span className="text-[#2d3748]">·</span>
          <span className="text-[#4a5568] text-[11px]" style={{ fontFamily: 'Roboto, sans-serif' }}>
            {video.views} views
          </span>
        </div>
        <h3
          className="text-white font-bold text-[14px] leading-snug group-hover:text-[#e01a2e] transition-colors duration-200"
          style={{ fontFamily: 'Montserrat, sans-serif' }}>
          
          {video.title}
        </h3>
      </div>
    </div>);

}